<ng-container [formGroup]="parent">
	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="dataSource"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		formArrayName="array"
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th mat-header-cell *matHeaderCellDef class="text-center">
				<em>No associated services</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let service">
				{{ service.name }}
			</td>
		</ng-container>

		<ng-container matColumnDef="type">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
			<td mat-cell *matCellDef="let service">
				{{ service.type.description }}
			</td>
		</ng-container>

		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
			<td mat-cell *matCellDef="let service">
				<div *ngIf="service.isActive; else inactive">Active</div>
				<ng-template #inactive>
					Inactive
				</ng-template>
			</td>
		</ng-container>

		<ng-container matColumnDef="edit">
			<th mat-header-cell *matHeaderCellDef>Edit</th>
			<td mat-cell *matCellDef="let service; let i = index">
				<button
					type="button"
					mat-icon-button
					(click)="editService(service)"
					color="primary"
				>
					<mat-icon>edit</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="dataSource.data?.length < 1"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="dataSource.data?.length > 0"
		></tr>
		<tr
			mat-row
			*matRowDef="let service; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator
			class.hidden="true"
			pageSize="5"
			[pageSizeOptions]="[5, 10]"
		></mat-paginator>
		<button
			type="button"
			class="mr-4"
			(click)="addService()"
			mat-mini-fab
			color="primary"
			matTooltip="Add Service"
		>
			<mat-icon>add</mat-icon>
		</button>
	</div>
</ng-container>
